import { SelfServiceConfig } from '../services/selfservice-loader.service';


export const PROD_SELFSERVICE_CONFIGS: Record<string, SelfServiceConfig> = {
  userRegistration: {
    name: 'User Registration',
    remoteUrl: 'https://myapps.motorolasolutions.com/user-registration-2',
    rootElementId: 'selfservice-app-root',
    rootElementTag: 'app-root',
    scriptFiles: [
      'https://myapps.motorolasolutions.com/user-registration-2/runtime.js',
      'https://myapps.motorolasolutions.com/user-registration-2/polyfills.js',
      'https://myapps.motorolasolutions.com/user-registration-2/main.js',
    ],
    styleFiles: [
      'https://myapps.motorolasolutions.com/user-registration-2/styles.css',
    ],
  },
};
